import React from "react";
import BaseSelect from "oc-ui/react/Select.jsx";

export default class Select extends BaseSelect {

    static defaultProps = {
        disableIfSingleOption: true
    }

    classNameSelect() {
        return undefined;
    }

    classNameGroup() {
        return "input-wrapper " + (this.props.hidden ? "disappear" : "appear");
    }

    extensionPointSpan() {
        return <span className={"unit"}>&#9660;</span>;
    }

}
